<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <div class="lineitem">
    <h2 class="item-title">{{ title }}</h2>
    <div
      class="item-row"
      :class="rowClass"
      :key="item.name"
      v-for="item in items"
    >
      <p>{{ item.name }}</p>
      <p>{{ item.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LineItemCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    borderless: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rowClass: function() {
      return {
        borderless: this.borderless
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-title {
  font-weight: bold;
  font-size: 1rem;
  margin-top: 2rem;
}

.item-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 2px solid rgba(0, 0, 0, 0.14);
  margin-top: 1rem;

  p {
    margin-bottom: 0.5rem;
  }
  &.borderless {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LineItemCard.vue